export const Mission = () => (
    <section
        id="missao"
        data-testid="mission-section"
        className="py-24 bg-[#f3f4f6] border-b border-neutral-200"
    >
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
            <div className="max-w-3xl space-y-6">
                <div className="text-xs font-bold uppercase tracking-widest text-[#ff6200]">
                    Sobre a Empresa &amp; Nossa Missão
                </div>
                <h2 className="display-type text-3xl sm:text-5xl text-neutral-900 leading-tight">
                    QUALIDADE, SEGURANÇA E PREÇO JUSTO NO TRANSPORTE.
                </h2>
                <p className="text-base text-neutral-700 leading-relaxed">
                    <span className="font-bold text-neutral-900">Missão:</span> É oferecer qualidade
                    e segurança com um orçamento acessível aos clientes. Compromisso com excelência
                    e profissionalismo fazem da nossa empresa uma das melhores do mercado.
                </p>
                <div className="p-5 bg-white rounded-lg border-l-4 border-[#ff6200] shadow-sm">
                    <p className="text-sm text-neutral-800 font-medium">
                        Atendimento em Miracatu e no corredor da Rodovia Régis Bittencourt com
                        equipamentos revisados e equipe treinada para socorro de veículos leves e
                        utilitários.
                    </p>
                </div>
            </div>
        </div>
    </section>
);
